import { useSettingQuery } from '@/features/auth/hooks/queries/useSettingQuery'

interface UseIsDietitianReturn {
  // 管理栄養士のアカウントか。未取得 / back 未デプロイ時は false (= 薬剤師) へ倒す。
  isDietitian: boolean
  // custom_setting の取得が終わったか (成否を問わない)。振り分けはこれが true になるまで
  // 何も描かない。先に薬剤師のページを描くと、一覧の取得など薬剤師の API が走ってから飛ぶ。
  isResolved: boolean
}

/**
 * ログインユーザーが管理栄養士の系統かを読む。useReleaseChannel と同じ配信路 (custom_setting)。
 * どちらの系統かはアカウント単位で決まり、ルートの振り分け (pages/profession-dispatchers) が使う。
 */
export const useIsDietitian = (): UseIsDietitianReturn => {
  const { data: setting, isLoading } = useSettingQuery()
  return {
    isDietitian: setting?.is_dietitian === true,
    isResolved: !isLoading,
  }
}
